module.exports = __webpack_public_path__ + "img/ZD.2a7ca2fe.png";